module.exports = __webpack_public_path__ + "static/media/fine.e71ad9e3.png";